import React from 'react';
import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <Zap size={18} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '0.4rem', color: 'hsl(200, 96%, 60%)' }} />
          Bet<span className="brand-accent">Max</span> Gaming Solution's
        </div>
        <div className="footer-links">
          <Link to="/sponsorlar" className="footer-link">Sponsorlar</Link>
          <Link to="/sans-oyunlari" className="footer-link">Sans Oyunlari</Link>
          <Link to="/cekilisler" className="footer-link">Cekilisler</Link>
          <Link to="/store" className="footer-link">Store</Link>
          <Link to="/iletisim" className="footer-link">Iletisim</Link>
        </div>
        <div className="footer-copy">
          &copy; 2023 BetMax Gaming Solution's. Tum haklari saklidir.
        </div>
      </div>
    </footer>
  );
};
